(function () {
  const DESKTOP_MIN = 880;
  const preloadedUrls = new Set();

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN;
  }

  function preloadUrl(url) {
    if (!url || preloadedUrls.has(url)) return;
    preloadedUrls.add(url);
    const img = new Image();
    img.decoding = 'async';
    img.src = url;
  }

  function preloadVariantImages(map) {
    if (!map) return;
    Object.keys(map).forEach((id) => {
      const entry = map[id];
      if (!entry) return;
      preloadUrl(entry.src);
      preloadUrl(entry.thumb);
      if (entry.srcset) {
        entry.srcset.split(',').forEach((part) => {
          const url = String(part).trim().split(/\s+/)[0];
          preloadUrl(url);
        });
      }
    });
  }

  function parseVariantImageMap(builder) {
    const el = builder?.querySelector('[data-lp-ritual-variant-images]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function readSlideState(slide) {
    const img = slide?.querySelector('img');
    if (!slide || !img) return null;
    return {
      imageId: slide.getAttribute('data-image-id') || '',
      src: img.getAttribute('src') || '',
      srcset: img.getAttribute('srcset') || '',
      sizes: img.getAttribute('sizes') || '',
      alt: img.getAttribute('alt') || '',
      width: img.getAttribute('width') || '',
      height: img.getAttribute('height') || ''
    };
  }

  function applySlideState(slide, state) {
    if (!slide || !state || !state.src) return;
    const img = slide.querySelector('img');
    if (!img) return;

    if (state.imageId) {
      slide.setAttribute('data-image-id', state.imageId);
    } else {
      slide.removeAttribute('data-image-id');
    }

    img.setAttribute('src', state.src);
    if (state.srcset) img.setAttribute('srcset', state.srcset);
    else img.removeAttribute('srcset');
    if (state.sizes) img.setAttribute('sizes', state.sizes);
    if (state.alt != null) img.setAttribute('alt', state.alt);
    if (state.width) img.setAttribute('width', state.width);
    if (state.height) img.setAttribute('height', state.height);
  }

  function setupOilFirstVariantGallery(container, mainGallery) {
    if (!container || !container.hasAttribute('data-lp-ritual-oil-gallery')) return;

    const sectionId = container.getAttribute('data-section-id') || '';
    const sectionRoot =
      container.closest('.shopify-section') ||
      container.closest('.lp-editorial-ritual')?.parentElement ||
      document;
    const builder =
      (sectionId &&
        sectionRoot.querySelector(
          `[data-lp-ritual-builder][data-section-id="${sectionId}"]`
        )) ||
      sectionRoot.querySelector('[data-lp-ritual-builder]');
    if (!builder) return;

    const imageMap = parseVariantImageMap(builder);
    if (!Object.keys(imageMap).length) return;

    preloadVariantImages(imageMap);

    const mainFirst =
      container.querySelector(
        '.main-product-gallery .swiper-slide[data-gallery-order="0"]'
      ) || container.querySelector('.main-product-gallery .swiper-slide');
    const thumbFirst =
      container.querySelector(
        '.thumbnail-gallery .swiper-slide[data-gallery-order="0"]'
      ) || container.querySelector('.thumbnail-gallery .swiper-slide');

    if (!mainFirst) return;

    const originalMain = readSlideState(mainFirst);
    const originalThumb = readSlideState(thumbFirst);
    let activeVariantId = null;

    function applyVariantImage(variantId) {
      const entry = imageMap[String(variantId)];
      if (entry && entry.src) {
        applySlideState(mainFirst, {
          imageId: String(entry.id || ''),
          src: entry.src,
          srcset: entry.srcset || '',
          sizes: entry.sizes || '(max-width: 880px) 100vw, 60vw',
          alt: entry.alt || '',
          width: String(entry.width || 960),
          height: String(entry.height || '')
        });
        if (thumbFirst && entry.thumb) {
          applySlideState(thumbFirst, {
            imageId: String(entry.id || ''),
            src: entry.thumb,
            srcset: '',
            sizes: '',
            alt: '',
            width: '80',
            height: String(
              entry.height && entry.width
                ? Math.max(1, Math.round((80 * entry.height) / entry.width))
                : 80
            )
          });
        }
        activeVariantId = String(variantId);
      } else if (originalMain) {
        applySlideState(mainFirst, originalMain);
        if (thumbFirst && originalThumb) applySlideState(thumbFirst, originalThumb);
        activeVariantId = null;
      }

      if (mainGallery && typeof mainGallery.slideTo === 'function') {
        mainGallery.slideTo(0);
      }
    }

    function onVariantChange(event) {
      const detail = event.detail || {};
      if (
        detail.sectionId &&
        sectionId &&
        String(detail.sectionId) !== String(sectionId)
      ) {
        return;
      }
      if (!detail.variantId) return;
      if (String(detail.variantId) === activeVariantId) return;
      applyVariantImage(detail.variantId);
    }

    document.addEventListener('lp-ritual:variant-change', onVariantChange);

    const selected = builder.querySelector('[data-lp-ritual-variant]:checked');
    if (selected) {
      const id = selected.getAttribute('data-variant-id');
      if (id && imageMap[id]) applyVariantImage(id);
    }
  }

  function initRitualGallery(container) {
    if (!container || container.dataset.lpEditorialRitualGalleryInit === 'true') return;
    if (typeof Swiper === 'undefined') return;

    const mainEl = container.querySelector('.main-product-gallery');
    const thumbEl = container.querySelector('.thumbnail-gallery');
    const thumbsCol = container.querySelector('[data-lp-ritual-thumbs-col]');
    const thumbNavUp = container.querySelector('[data-lp-ritual-thumbs-prev]');
    const thumbNavDown = container.querySelector('[data-lp-ritual-thumbs-next]');
    if (!mainEl) return;

    container.dataset.lpEditorialRitualGalleryInit = 'true';

    let thumbGallery = null;

    function getMainGalleryHeight() {
      const width = mainEl.offsetWidth;
      if (width > 0) return width;
      return mainEl.getBoundingClientRect().height;
    }

    function syncThumbGalleryHeight() {
      if (!thumbEl) return;

      if (!isDesktop()) {
        thumbEl.style.removeProperty('height');
        thumbsCol?.style.removeProperty('max-height');
        thumbsCol?.classList.remove('is-scrollable');
        return;
      }

      const mainHeight = getMainGalleryHeight();
      if (mainHeight <= 0) return;

      if (thumbsCol) {
        thumbsCol.style.maxHeight = `${mainHeight}px`;
      }

      const colStyles = thumbsCol ? getComputedStyle(thumbsCol) : null;
      const colGap = colStyles ? parseFloat(colStyles.rowGap || colStyles.gap || '0') : 0;
      const navUpHeight = thumbNavUp?.offsetHeight || 0;
      const navDownHeight = thumbNavDown?.offsetHeight || 0;
      const navVisible =
        !thumbNavUp?.hasAttribute('hidden') || !thumbNavDown?.hasAttribute('hidden');
      const navBlock = navVisible ? navUpHeight + navDownHeight + colGap * 2 : 0;
      const thumbHeight = Math.max(mainHeight - navBlock, 100);

      thumbEl.style.height = `${thumbHeight}px`;
    }

    function syncThumbNavVisibility() {
      if (!thumbGallery || !isDesktop()) {
        thumbNavUp?.setAttribute('hidden', '');
        thumbNavDown?.setAttribute('hidden', '');
        thumbsCol?.classList.remove('is-scrollable');
        return;
      }

      const wrapper = thumbEl.querySelector('.swiper-wrapper');
      const scrollable =
        wrapper && wrapper.scrollHeight > thumbEl.clientHeight + 1;

      thumbsCol?.classList.toggle('is-scrollable', scrollable);

      if (!scrollable) {
        thumbNavUp?.setAttribute('hidden', '');
        thumbNavDown?.setAttribute('hidden', '');
        return;
      }

      if (thumbGallery.isBeginning) {
        thumbNavUp?.setAttribute('hidden', '');
      } else {
        thumbNavUp?.removeAttribute('hidden');
      }

      if (thumbGallery.isEnd) {
        thumbNavDown?.setAttribute('hidden', '');
      } else {
        thumbNavDown?.removeAttribute('hidden');
      }
    }

    function bindThumbNav() {
      thumbNavUp?.addEventListener('click', () => {
        thumbGallery?.slidePrev();
      });

      thumbNavDown?.addEventListener('click', () => {
        thumbGallery?.slideNext();
      });
    }

    if (thumbEl && thumbEl.querySelector('.swiper-slide')) {
      thumbGallery = new Swiper(thumbEl, {
        resizeObserver: false,
        loop: false,
        spaceBetween: 8,
        direction: 'horizontal',
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        mousewheel: false,
        breakpoints: {
          0: {
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 8,
            mousewheel: false
          },
          [DESKTOP_MIN]: {
            direction: 'vertical',
            slidesPerView: 'auto',
            spaceBetween: 8,
            mousewheel: {
              forceToAxis: true,
              releaseOnEdges: true,
              sensitivity: 1
            }
          }
        },
        on: {
          init(swiperInstance) {
            syncThumbGalleryHeight();
            syncThumbNavVisibility();
            swiperInstance.update();
          },
          resize() {
            syncThumbGalleryHeight();
            syncThumbNavVisibility();
          },
          slideChange: syncThumbNavVisibility,
          reachBeginning: syncThumbNavVisibility,
          reachEnd: syncThumbNavVisibility,
          fromEdge: syncThumbNavVisibility,
          progress: syncThumbNavVisibility
        }
      });

      bindThumbNav();
    }

    const mainGallery = new Swiper(mainEl, {
      resizeObserver: false,
      loop: false,
      spaceBetween: 0,
      slidesPerView: 1,
      pagination: {
        el: mainEl.querySelector('.swiper-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: container.querySelector('.swiper-arrow-next'),
        prevEl: container.querySelector('.swiper-arrow-prev')
      },
      thumbs: thumbGallery ? { swiper: thumbGallery } : undefined,
      breakpoints: {
        0: {
          pagination: {
            el: mainEl.querySelector('.swiper-pagination'),
            clickable: true
          }
        },
        [DESKTOP_MIN]: {
          pagination: false
        }
      }
    });

    if (thumbGallery) {
      thumbEl.querySelectorAll('.swiper-slide').forEach((slide, index) => {
        slide.addEventListener('click', () => {
          mainGallery.slideTo(index);
        });
      });

      mainGallery.on('slideChange', () => {
        thumbEl
          .querySelectorAll('.swiper-slide')
          .forEach((slide, index) => {
            slide.classList.toggle(
              'swiper-slide-thumb-active',
              index === mainGallery.activeIndex
            );
          });

        if (isDesktop()) {
          thumbGallery.slideTo(mainGallery.activeIndex);
        }
      });

      const firstThumb = thumbEl.querySelector('.swiper-slide');
      if (firstThumb) firstThumb.classList.add('swiper-slide-thumb-active');
    }

    const onLayoutChange = () => {
      syncThumbGalleryHeight();
      thumbGallery?.update();
      syncThumbNavVisibility();
      syncThumbGalleryHeight();
      thumbGallery?.update();
    };

    window.addEventListener('resize', onLayoutChange, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(onLayoutChange);
      resizeObserver.observe(mainEl);
    }

    mainEl.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', onLayoutChange, { once: true });
      }
    });

    onLayoutChange();
    requestAnimationFrame(onLayoutChange);

    setupOilFirstVariantGallery(container, mainGallery);
  }

  function initAll() {
    document
      .querySelectorAll('[data-lp-editorial-ritual-gallery]')
      .forEach(initRitualGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const gallery = event.target.querySelector('[data-lp-editorial-ritual-gallery]');
    if (gallery) {
      gallery.dataset.lpEditorialRitualGalleryInit = '';
      initRitualGallery(gallery);
    }
  });
})();
